import React, { useEffect, useState } from "react";
import { api, formatApiError } from "@/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { toast } from "sonner";
import { Field } from "./shared";

const NUM = [["periodicite_mois", "Périodicité standard (mois)", "Par défaut 60 = 5 ans"], ["periodicite_renforce_mois", "Suivi renforcé (mois)", "Par défaut 36"], ["delai_embauche_mois", "Visite d'embauche sous (mois)", "Par défaut 3"], ["alerte_jours", "Alerter à J- (jours)", "Par défaut 30"]];

export function MedicalSettingsDialog({ open, onClose, onSaved }) {
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  useEffect(() => { if (open) api.get("/chef/visites-medicales/settings").then((r) => setS(r.data)).catch((e) => toast.error(formatApiError(e.response?.data?.detail))); }, [open]);
  const save = async () => {
    setBusy(true);
    try { await api.put("/chef/visites-medicales/settings", { ...s, ...Object.fromEntries(NUM.map(([k]) => [k, Number(s[k])])) }); toast.success("Réglages enregistrés"); onSaved?.(); onClose(); }
    catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };
  const set = (k) => (e) => setS({ ...s, [k]: e.target.value });
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-lg" data-testid="vm-settings-dialog">
        <DialogHeader><DialogTitle className="font-display text-2xl font-black">Réglages des visites médicales</DialogTitle></DialogHeader>
        {s && (
          <div className="space-y-4">
            <div className="grid grid-cols-2 gap-3">{NUM.map(([k, l, h]) => <Field key={k} label={l}><Input type="number" min="1" value={s[k]} onChange={set(k)} data-testid={`vm-set-${k}`} className="h-10" /><div className="text-[10px] text-[#868E96]">{h}</div></Field>)}</div>
            <div className="text-[10px] uppercase tracking-[0.2em] font-bold text-[#868E96]">Service de prévention et de santé au travail</div>
            <Field label="Nom du service"><Input value={s.service_nom} onChange={set("service_nom")} placeholder="ex. AST 75 — Centre …" data-testid="vm-set-service_nom" className="h-10" /></Field>
            <Field label="Adresse"><Input value={s.service_adresse} onChange={set("service_adresse")} data-testid="vm-set-service_adresse" className="h-10" /></Field>
            <Field label="Téléphone"><Input value={s.service_telephone} onChange={set("service_telephone")} data-testid="vm-set-service_telephone" className="h-10" /></Field>
            <p className="text-[11px] text-[#868E96]">Ces coordonnées pré-remplissent les convocations.</p>
          </div>
        )}
        <DialogFooter><Button variant="outline" onClick={onClose} className="h-10">Annuler</Button><Button onClick={save} disabled={busy || !s} data-testid="vm-set-save" className="h-10 bg-[#002FA7] hover:bg-[#00247F] text-white">Enregistrer</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
